<svelte:options tag={null} />

<script lang="ts">
  import { onMount } from 'svelte/internal';
  import { EventHandler } from '../../utilities/EventHandler';
  import type { CheckboxGroupOption } from './checkboxgroup.types';

  export let id: string;
  export let options: string;
  export let legend: string;
  let eventHandler = new EventHandler();

  $: parsedOptions = options
    ? (JSON.parse(options) as CheckboxGroupOption[])
    : [];
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function selectValue(value?: string) {
    if (!parsedOptions || !parsedOptions.length) {
      return;
    }
    parsedOptions = parsedOptions.map((opt) => {
      const checked = opt.value === value ? !opt.checked : opt.checked;
      return { ...opt, checked };
    });
    eventHandler.dispatch('change', value);
  }

  onMount(() => {
    selectValue('');
  });
</script>

<div {id} class="checkbox-group-container" {...attributes}>
  <fieldset class="mc-field mc-field--group">
    {#if legend && legend.length}
      <legend class="mc-field__legend">
        {legend}
      </legend>
    {/if}
    <div class="mc-field__container">
      {#each parsedOptions as opt (opt.id)}
        <div class="mc-checkbox mc-field__item {$$props.class}">
          <input
            type="checkbox"
            class="mc-checkbox__input {opt.isinvalid ? ' is-invalid' : ''}"
            id={opt.id}
            name={opt.name}
            checked={opt.checked}
            disabled={opt.disabled}
            indeterminate={opt.indeterminate}
            aria-invalid={opt.isinvalid}
            on:click={() => selectValue(opt.value)}
          />
          {#if opt.label}
            <label for={opt.id} class="mc-checkbox__label">{opt.label}</label>
          {/if}
        </div>
      {/each}
    </div>
  </fieldset>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.checkbox';
  @import '@mozaic-ds/styles/components/c.fields';
</style>
